module.exports = "https://static.moomoo.com/components/invite-guide/images/forbidden-moomoo.8bbb547f8e.png";